import React from 'react';
import { useNavigate } from 'react-router-dom';
import { CloseModalIcon, InformationIcon } from '../../Assets/Images/CelcomSvgImages';

const DeviceSwapNotAvailableModal = () => {
    const navigate = useNavigate();

    return (
        <div className="modal fade logout-modal"
            id="deviceSwapModal" data-backdrop="static"
            data-keyboard="false" tabIndex="-1" aria-labelledby="deviceSwapModalLabel"
            aria-modal="true" role="dialog">
            <div className="modal-dialog">
                <div className="modal-content">
                    <div className="modal-header pb-0">
                        <div className="wrapper-modal-header pt-5">
                            <div className="modal-header-title-section">
                                <InformationIcon fill={"#FF9700"} />
                                <div className="modal-header-title-item">
                                    {"Oops!"}
                                </div>
                                <div className="modal-body pt-0">
                                    <div className="wrapper-modal-body">
                                        {"Device swap function is currently unavailable, serial number cannot be entered. Kindly input the device information in E-SAF, ensuring both the faulty unit's serial number and the replacement unit's serial number are entered correctly."}
                                    </div>
                                </div>
                                
                            </div>
                            <button type="button" className="close" data-dismiss="modal" aria-label="Close">
                                <span aria-hidden="true">
                                    <CloseModalIcon />
                                </span>
                            </button>
                        </div>
                    </div>
                    
                    <div className="modal-footer">
                        <div className="okay-btn-section" data-dismiss="modal" onClick={() => {
                            //navigate("/")
                        }}>
                            <span>{"Close"}</span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default DeviceSwapNotAvailableModal;